import React from 'react';
import PropTypes from 'prop-types';

export const Footer = ({ children }) => <div className="footer">{children}</div>;

Footer.propTypes = { children: PropTypes.node.isRequired };

Footer.displayName = 'Card.Footer';

export default Footer;
